import React from 'react'
import { motion } from 'motion/react';
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const Capabilities = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Count up only the first time the element is in view
    threshold: 0.5, // Trigger when 50% of the element is visible
  });

  return (
    <div className="bg-gradient-to-b from-[#E6DFFF]  to-white">
      <div className="max-w-screen-2xl mx-auto px-5 lg:px-20 pt-10 lg:pt-28">
        <div className="lg:flex justify-between">
          <div className="lg:w-[40%]">
            <div className="relative mb-9 ml-5 lg:ml-0">
              <motion.h3
                initial={{ x: -100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                className="poppins-regular text-primary z-20 relative"
              >
                OUR CAPABILITIES
              </motion.h3>
              <div className="size-16 bg-[#E7E9FF] rounded-full absolute -top-5 -left-5"></div>
            </div>
            <motion.h2
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="text-4xl sm:text-5xl montserrat-regular text-secondary mb-5 lg:mb-9"
            >
              <span className="montserrat-semibold">Unlocking</span> Your{" "}
              Financial <span className="montserrat-semibold">Potential</span>
            </motion.h2>
          </div>
          <div className="lg:w-[50%]">
            <div>
              <motion.p
                initial={{ x: -100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 1 }}
                viewport={{ once: true }}
                className="montserrat-medium text-secondary mb-5 lg:mb-9"
              >
                Finalyze revolutionizes financial management through
                personalized service. Founded by industry leaders, we prioritize
                transparency, integrity, and client-centricity for client
                success.
              </motion.p>
              <div ref={ref} className=" flex flex-col lg:flex-row gap-4 lg:gap-0 justify-between">
                <div>
                  <p className="text-secondary text-xl montserrat-medium">
                    Growth Solution
                  </p>
                  { inView && (<p className="text-secondary montserrat-bold text-5xl">
                    <CountUp start={0} end={125} duration={3} />
                    <span className="text-primary">+</span>
                  </p>)}
                </div>
                <div>
                  <p className="text-secondary text-xl montserrat-medium">
                    Certified Expert
                  </p>
                  {inView && (<p className="text-secondary montserrat-bold text-5xl">
                    <CountUp start={0} end={110} duration={3} />
                    <span className="text-primary">+</span>
                  </p>)}
                </div>
                <div>
                  <p className="text-secondary text-xl montserrat-medium">
                    Success Rate
                  </p>
                  {inView && (<p className="text-secondary montserrat-bold text-5xl">
                    <CountUp start={0} end={85} duration={3} />
                    <span className="text-primary">%</span>
                  </p>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Capabilities